"use client";

import { startTransition, useEffect } from "react";
import { useRouter } from "next/navigation";
import { useClaritySession } from "@/lib/auth/auth-store";
import {
  createTenantHref,
  getFirstAccessibleTenantId,
} from "@/lib/auth/tenant-access";

export function AuthEntryRedirect() {
  const router = useRouter();
  const session = useClaritySession();
  const firstTenantId = getFirstAccessibleTenantId(session.tenantIds);

  useEffect(() => {
    if (session.status !== "authenticated" || !firstTenantId) {
      return;
    }

    startTransition(() => {
      router.replace(createTenantHref(firstTenantId));
    });
  }, [firstTenantId, router, session.status]);

  if (session.status === "authenticated" && !firstTenantId) {
    return (
      <section className="border-border bg-surface shadow-card rounded-4xl border p-8 sm:p-10">
        <p className="text-label-md text-content-tertiary tracking-[0.16em] uppercase">
          Practice Access
        </p>
        <h1 className="font-display text-foreground mt-4 text-4xl font-bold tracking-[-0.02em]">
          No practice access is available.
        </h1>
        <p className="text-body-lg text-content-secondary mt-4 max-w-2xl">
          Your session is authenticated, but it does not include any valid
          practiceId access claims for ClarityOS.
        </p>
      </section>
    );
  }

  return (
    <section className="border-border bg-surface shadow-card rounded-[2rem] border p-8 sm:p-10">
      <p className="text-label-md text-content-tertiary tracking-[0.16em] uppercase">
        Practice Redirect
      </p>
      <h1 className="font-display text-foreground mt-4 text-4xl font-bold tracking-[-0.02em]">
        Selecting your first practice.
      </h1>
      <p className="text-body-lg text-content-secondary mt-4 max-w-2xl">
        The ClarityOS homepage resolves into your first available practice from
        your authenticated session claims.
      </p>
    </section>
  );
}
